import sha1 from 'sha1';
import appSettings from '../../appSettings';

const MarketingRedirect = (email, url) => {
    const SECURITY_CODE = appSettings.MARKETING_SECURITY_TOKEN;

    const createSSOURL = () => {
        const sb = [];
        const timestamp = new Date().toISOString();
        let out = null;
        if (!url || !SECURITY_CODE) {
            return '';
        }
        if (!email) {
            sb.push(url);
        } else {
            sb.push(url);
            sb.push('/main/index.php?p=user.login&pageaction=autologin&login_field=email&login=');
            sb.push(email);
            sb.push('&SSO_version=2&source_url=');
            sb.push(url);
            sb.push('&destination_url=');
            sb.push(url);
            sb.push('&date=');
            sb.push(timestamp);
            sb.push('&stoken=');
            sb.push(encryptTokenSHA1(timestamp));
            sb.push('&registerinvalid=true');
        }
        out = sb.join('');
        return out;
    }

    const encryptTokenSHA1 = (timestamp) => {
        const inputString = url + url + email + timestamp + SECURITY_CODE;
        return sha1(inputString);
    }

    return createSSOURL();
}

export default MarketingRedirect;